import React from 'react';

export interface FormErrorProps {
	message?: string | null;
	className?: string;
}

/**
 * Inline form-level error block. Renders nothing when `message` is empty.
 *
 * Styling depends on consumer-side CSS class `auth-text-critical`.
 */
export const FormError: React.FC<FormErrorProps> = ({ message, className = '' }) => {
	if (!message) return null;
	return <div className={`auth-text-critical ${className}`}>{message}</div>;
};
